// extracted by mini-css-extract-plugin
export default {"category":"category__nnKHG0Z2QEaT","category_name":"category_name__uxqZedj0BAS1","category_replies":"category_replies__XtB2un4rch_M"};